/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from 'ethers';
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from 'ethers';
import type {NonPayableOverrides} from '../../common';
import type {
  ExchangeToken,
  ExchangeTokenInterface,
} from '../../contracts/ExchangeToken';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'creator',
        type: 'address',
      },
      {
        internalType: 'string',
        name: '_name',
        type: 'string',
      },
      {
        internalType: 'string',
        name: '_symbol',
        type: 'string',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'AccessControlBadConfirmation',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        internalType: 'bytes32',
        name: 'neededRole',
        type: 'bytes32',
      },
    ],
    name: 'AccessControlUnauthorizedAccount',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'allowance',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'needed',
        type: 'uint256',
      },
    ],
    name: 'ERC20InsufficientAllowance',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'balance',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'needed',
        type: 'uint256',
      },
    ],
    name: 'ERC20InsufficientBalance',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'approver',
        type: 'address',
      },
    ],
    name: 'ERC20InvalidApprover',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'receiver',
        type: 'address',
      },
    ],
    name: 'ERC20InvalidReceiver',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
    ],
    name: 'ERC20InvalidSender',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
    ],
    name: 'ERC20InvalidSpender',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'contractAddress',
        type: 'address',
      },
    ],
    name: 'DeliveryRequested',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'previousAdminRole',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'newAdminRole',
        type: 'bytes32',
      },
    ],
    name: 'RoleAdminChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
    ],
    name: 'RoleGranted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
    ],
    name: 'RoleRevoked',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    inputs: [],
    name: 'CASHIER_ROLE',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'DEFAULT_ADMIN_ROLE',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'PARAMS_ROLE',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'wrapperAddress',
        type: 'address',
      },
    ],
    name: 'balanceOfContract',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'burnValue',
        type: 'uint256',
      },
    ],
    name: 'burnToken',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'categories',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'createExchangeRateDivider',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'contractValue',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'wrapperAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'contractDivider',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'providerAddress',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'ratingsEnabled',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'requiresPayment',
        type: 'bool',
      },
      {
        internalType: 'uint256',
        name: 'requiresSubs',
        type: 'uint256',
      },
      {
        internalType: 'string',
        name: 'category',
        type: 'string',
      },
      {
        internalType: 'address',
        name: 'originalContract',
        type: 'address',
      },
    ],
    name: 'createServiceUserContract',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'exchangeComission',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'exchangeLockTime',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
    ],
    name: 'getRoleAdmin',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'grantRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'hasRole',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'callerConfirmation',
        type: 'address',
      },
    ],
    name: 'renounceRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'contractAddress',
        type: 'address',
      },
    ],
    name: 'requestDelivery',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'revokeRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'serviceComission',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'services',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'divider',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'commission',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'serviceFee',
        type: 'uint256',
      },
    ],
    name: 'setParams',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4',
      },
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'transactValue',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'wrapperAddress',
        type: 'address',
      },
    ],
    name: 'withdrawTo',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'wrapperAddress',
        type: 'address',
      },
    ],
    name: 'wrapperDecimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const;

const _bytecode =
  '0x60a0604052600160075560026008556203f4806009556002600a5534801561002657600080fd5b506040516166e13803806166e1833981016040819052610045916103da565b8181600361005383826104eb565b50600461006082826104eb565b5050506100948361007561010360201b60201c565b61008090600a6106a6565b61008f90640218711a006106bc565b610108565b61009f600084610147565b506100ca7f4af29447b0b3ab714a8512e6f69c515e9803c066fb6c4e2df49be42a14a63c0d84610147565b506100f57fff3317e1e0e8c784290b957ee9b65ea8fe96420c4819db463283b95ecbe4a3fe84610147565b505030608052506106e69050565b601290565b6001600160a01b0382166101375760405163ec442f0560e01b8152600060048201526024015b60405180910390fd5b610143600083836101f7565b5050565b60008281526005602090815260408083206001600160a01b038516845290915281205460ff166101ed5760008381526005602090815260408083206001600160a01b03861684529091529020805460ff191660011790556101a53390565b6001600160a01b0316826001600160a01b0316847f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45060016101f1565b5060005b92915050565b6001600160a01b03831661022257806002600082825461021791906106d3565b909155506102949050565b6001600160a01b038316600090815260208190526040902054818110156102755760405163391434e360e21b81526001600160a01b0385166004820152602481018290526044810183905260640161012e565b6001600160a01b03841660009081526020819052604090209082900390555b6001600160a01b0382166102b0576002805482900390556102cf565b6001600160a01b03821660009081526020819052604090208054820190555b816001600160a01b0316836001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef8360405161031491815260200190565b60405180910390a3505050565b634e487b7160e01b600052604160045260246000fd5b600082601f83011261034857600080fd5b81516001600160401b0381111561036157610361610321565b604051601f8201601f19908116603f011681016001600160401b038111828210171561038f5761038f610321565b6040528181528382016020018510156103a757600080fd5b60005b828110156103c6576020818601810151838301820152016103aa565b506000918101602001919091529392505050565b6000806000606084860312156103ef57600080fd5b83516001600160a01b038116811461040657600080fd5b60208501519093506001600160401b0381111561042257600080fd5b61042e86828701610337565b604086015190935090506001600160401b0381111561044c57600080fd5b61045886828701610337565b9150509250925092565b600181811c9082168061047657607f821691505b60208210810361049657634e487b7160e01b600052602260045260246000fd5b50919050565b601f8211156104e657806000526020600020601f840160051c810160208510156104c35750805b601f840160051c820191505b818110156104e357600081556001016104cf565b50505b505050565b81516001600160401b0381111561050457610504610321565b610518816105128454610462565b8461049c565b6020601f82116001811461054c57600083156105345750848201515b600019600385901b1c1916600184901b1784556104e3565b600084815260208120601f198516915b8281101561057c578785015182556020948501946001909201910161055c565b508482101561059a5786840151600019600387901b60f8161c191681555b50505050600190811b01905550565b634e487b7160e01b600052601160045260246000fd5b6001815b60018411156105fa578085048111156105de576105de6105a9565b60018416156105ec57908102905b60019390931c9280026105c3565b935093915050565b600082610611575060016101f1565b8161061e575060006101f1565b8160018114610634576002811461063e5761065a565b60019150506101f1565b60ff84111561064f5761064f6105a9565b50506001821b6101f1565b5060208310610133831016604e8410600b841016171561067d575081810a6101f1565b61068a60001984846105bf565b806000190482111561069e5761069e6105a9565b029392505050565b60006106b560ff841683610602565b9392505050565b80820281158282048414176101f1576101f16105a9565b808201808211156101f1576101f16105a9565b608051615fe061070160003960006106800152615fe06000f3fe608060405234801561001057600080fd5b50600436106101e55760003560e01c80635a0ce6761161010f578063b7fd9684116100a2578063d547741f11610071578063d547741f14610457578063dd48087f1461046a578063dd62ed3e1461047d578063e31e2cab146104b657600080fd5b8063b7fd968414610401578063bb5bc87f14610428578063c22c4f4314610431578063c4e2c1e61461044457600080fd5b806391d14854116100de57806391d14854146103a557806395d89b41146103de578063a217fddf146103e6578063a9059cbb146103ee57600080fd5b80635a0ce676146103435780636caa97ac1461035657806370a08231146103695780637b47ec1a1461039257600080fd5b8063248a9ca31161018757806336568abe1161015657806336568abe146102ed57806339a36ea5146103005780634791abe1146103095780634fc620421461031c57600080fd5b8063248a9ca3146102975780632f2ff15d146102ba578063313ce567146102cf57806332a30d4c146102e457600080fd5b8063095ea7b3116101c3578063095ea7b31461023e57806318160ddd1461025157806321bdd60d1461025957806323b872dd1461028457600080fd5b806301ffc9a7146101ea57806306fdde031461021257806308c171da14610227575b600080fd5b6101fd6101f83660046114f3565b6104c9565b60405190151581526020015b60405180910390f35b61021a610562565b6040516102099190611559565b610230600a5481565b604051908152602001610209565b6101fd61024c3660046115ac565b6105f4565b600254610230565b61026c61026736600461168b565b61060c565b6040516001600160a01b039091168152602001610209565b6101fd61029236600461174c565b61083a565b6102306102a536600461178d565b60009081526005602052604090206001015490565b6102cd6102c83660046117a6565b61085e565b005b60125b60405160ff9091168152602001610209565b61023060075481565b6102cd6102fb3660046117a6565b610889565b61023060085481565b6102cd6103173660046117d6565b6108da565b6102307f4af29447b0b3ab714a8512e6f69c515e9803c066fb6c4e2df49be42a14a63c0d81565b6102cd6103513660046117f3565b610acd565b61026c61036436600461181f565b610bf6565b6102306103773660046117d6565b6001600160a01b031660009081526020819052604090205490565b6102cd6103a036600461178d565b610c3d565b6101fd6103b33660046117a6565b60009182526005602090815260408084206001600160a01b0393909316845291905290205460ff1690565b61021a610c4a565b610230600081565b6101fd6103fc3660046115ac565b610c59565b6102307fff3317e1e0e8c784290b957ee9b65ea8fe96420c4819db463283b95ecbe4a3fe81565b61023060095481565b61026c61043f36600461178d565b610c67565b6101fd610452366004611864565b610c91565b6102cd6104653660046117a6565b610de3565b6102306104783660046117d6565b610e08565b61023061048b3660046118a6565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205490565b6102d26104c43660046117d6565b610e95565b60007fffffffff0000000000000000000000000000000000000000000000000000000082167f7965db0b00000000000000000000000000000000000000000000000000000000148061055c57507f01ffc9a7000000000000000000000000000000000000000000000000000000007fffffffff000000000000000000000000000000000000000000000000000000008316145b92915050565b606060038054610571906118d4565b80601f016020809104026020016040519081016040528092919081815260200182805461059d906118d4565b80156105ea5780601f106105bf576101008083540402835291602001916105ea565b820191906000526020600020905b8154815290600101906020018083116105cd57829003601f168201915b5050505050905090565b600033610602818585610f02565b5060019392505050565b6000806007548a61061b601290565b61062690600a611a0b565b610630908f611a1a565b61063a9190611a31565b6106449190611a31565b905061064f81610c3d565b60008a61065b8d610e95565b61066690600a611a0b565b610670908f611a1a565b61067a9190611a31565b905060007f00000000000000000000000000000000000000000000000000000000000000008d33848e600a548f8f8f8f8e6040516106b7906114e6565b6106cb9b9a99989796959493929190611a53565b604051809103906000f0801580156106e7573d6000803e3d6000fd5b50600680546001810182556000919091527ff652222313e28459528d920b65115c16c04f3efc82aaedc97be59f3f377c0d3f01805473ffffffffffffffffffffffffffffffffffffffff19166001600160a01b0383161790556040519091508190600b90610756908990611aec565b908152604051602091819003820190208054600181018255600091825291902001805473ffffffffffffffffffffffffffffffffffffffff19166001600160a01b0383811691909117909155861615610828576040517f0f82d3a70000000000000000000000000000000000000000000000000000000081523360048201526001600160a01b038281166024830152879190821690630f82d3a790604401600060405180830381600087803b15801561080e57600080fd5b505af1158015610822573d6000803e3d6000fd5b50505050505b9e9d5050505050505050505050505050565b600033610848858285610f0f565b610853858585610fa0565b506001949350505050565b60008281526005602052604090206001015461087981611018565b6108838383611022565b50505050565b6001600160a01b03811633146108cb576040517f6697b23200000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6108d582826110d0565b505050565b6000819050306001600160a01b0316816001600160a01b031663b9780f336040518163ffffffff1660e01b8152600401602060405180830381865afa158015610927573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061094b9190611b08565b6001600160a01b0316146109cb5760405162461bcd60e51b8152602060048201526024808201527f43616e206f6e6c79207265717565737420666f72206f776e656420636f6e747260448201527f616374730000000000000000000000000000000000000000000000000000000060648201526084015b60405180910390fd5b6001816001600160a01b031663c19d93fb6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610a0b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a2f9190611b3b565b6004811115610a4057610a40611b25565b14610a8d5760405162461bcd60e51b815260206004820152601e60248201527f5265717569726573206c6f636b656420636f6e7472616374207374617465000060448201526064016109c2565b6040516001600160a01b03831681527f9cf215cc99cf3cb3537c5e3d4e60149dd8442ec3d89b6da547f85550e8c9781e9060200160405180910390a15050565b7f4af29447b0b3ab714a8512e6f69c515e9803c066fb6c4e2df49be42a14a63c0d610af781611018565b60008311610b475760405162461bcd60e51b815260206004820181905260248201527f616c6c20706172616d73206d75737420626520626967676572207468616e203060448201526064016109c2565b60008411610b975760405162461bcd60e51b815260206004820181905260248201527f616c6c20706172616d73206d75737420626520626967676572207468616e203060448201526064016109c2565b60008211610be75760405162461bcd60e51b815260206004820181905260248201527f616c6c20706172616d73206d75737420626520626967676572207468616e203060448201526064016109c2565b50600792909255600855600a55565b8151602081840181018051600b825292820191850191909120919052805482908110610c2157600080fd5b6000918252602090912001546001600160a01b03169150829050565b610c478133611157565b50565b606060048054610571906118d4565b600033610602818585610fa0565b60068181548110610c7757600080fd5b6000918252602090912001546001600160a01b0316905081565b60007fff3317e1e0e8c784290b957ee9b65ea8fe96420c4819db463283b95ecbe4a3fe610cbd81611018565b6040517f095ea7b30000000000000000000000000000000000000000000000000000000081523060048201526024810185905283906001600160a01b0382169063095ea7b3906044016020604051808303816000875af1158015610d25573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d499190611b5c565b506040517fa9059cbb0000000000000000000000000000000000000000000000000000000081526001600160a01b0387811660048301526024820187905282169063a9059cbb906044016020604051808303816000875af1158015610db2573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610dd69190611b5c565b5060019695505050505050565b600082815260056020526040902060010154610dfe81611018565b61088383836110d0565b6040517f70a0823100000000000000000000000000000000000000000000000000000000815230600482015260009081906001600160a01b038416906370a0823190602401602060405180830381865afa158015610e6a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610e8e9190611b79565b9392505050565b6000816001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa925050508015610ef1575060408051601f3d908101601f19168201909252610eee91810190611b92565b60015b61055c57506000919050565b919050565b6108d583838360016111f8565b6001600160a01b0383811660009081526001602090815260408083209386168352929052205460001981146108835781811015610f91576040517ffb8f41b20000000000000000000000000000000000000000000000000000000081526001600160a01b038416600482015260248101829052604481018390526064016109c2565b610883848484840360006111f8565b6001600160a01b038316610fca57604051634b637e8f60e11b8152600060048201526024016109c2565b6001600160a01b03821661100d576040517fec442f05000000000000000000000000000000000000000000000000000000008152600060048201526024016109c2565b6108d58383836112ff565b610c478133611442565b60008281526005602090815260408083206001600160a01b038516845290915281205460ff166110c85760008381526005602090815260408083206001600160a01b03861684529091529020805460ff191660011790556110803390565b6001600160a01b0316826001600160a01b0316847f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a450600161055c565b50600061055c565b60008281526005602090815260408083206001600160a01b038516845290915281205460ff16156110c85760008381526005602090815260408083206001600160a01b0386168085529252808320805460ff1916905551339286917ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9190a450600161055c565b81611177826001600160a01b031660009081526020819052604090205490565b116111ea5760405162461bcd60e51b815260206004820152602860248201527f4e6f7420656e6f75676820746f6b656e20696e20796f7572206163636f756e7460448201527f20746f206275726e00000000000000000000000000000000000000000000000060648201526084016109c2565b6111f481836114b0565b5050565b6001600160a01b03841661123b576040517fe602df05000000000000000000000000000000000000000000000000000000008152600060048201526024016109c2565b6001600160a01b03831661127e576040517f94280d62000000000000000000000000000000000000000000000000000000008152600060048201526024016109c2565b6001600160a01b038085166000908152600160209081526040808320938716835292905220829055801561088357826001600160a01b0316846001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925846040516112f191815260200190565b60405180910390a350505050565b6001600160a01b03831661132a57806002600082825461131f9190611bb5565b909155506113b59050565b6001600160a01b03831660009081526020819052604090205481811015611396576040517fe450d38c0000000000000000000000000000000000000000000000000000000081526001600160a01b038516600482015260248101829052604481018390526064016109c2565b6001600160a01b03841660009081526020819052604090209082900390555b6001600160a01b0382166113d1576002805482900390556113f0565b6001600160a01b03821660009081526020819052604090208054820190555b816001600160a01b0316836001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef8360405161143591815260200190565b60405180910390a3505050565b60008281526005602090815260408083206001600160a01b038516845290915290205460ff166111f4576040517fe2517d3f0000000000000000000000000000000000000000000000000000000081526001600160a01b0382166004820152602481018390526044016109c2565b6001600160a01b0382166114da57604051634b637e8f60e11b8152600060048201526024016109c2565b6111f4826000836112ff565b6143e280611bc983390190565b60006020828403121561150557600080fd5b81357fffffffff0000000000000000000000000000000000000000000000000000000081168114610e8e57600080fd5b60005b83811015611550578181015183820152602001611538565b50506000910152565b6020815260008251806020840152611578816040850160208701611535565b601f01601f19169190910160400192915050565b6001600160a01b0381168114610c4757600080fd5b8035610efd8161158c565b600080604083850312156115bf57600080fd5b82356115ca8161158c565b946020939093013593505050565b8015158114610c4757600080fd5b634e487b7160e01b600052604160045260246000fd5b600082601f83011261160d57600080fd5b813567ffffffffffffffff811115611627576116276115e6565b604051601f8201601f19908116603f0116810167ffffffffffffffff81118282101715611656576116566115e6565b60405281815283820160200185101561166e57600080fd5b816020850160208301376000918101602001919091529392505050565b6000806000806000806000806000806101408b8d0312156116ab57600080fd5b8a35995060208b01356116bd8161158c565b985060408b0135975060608b01356116d48161158c565b965060808b01356116e48161158c565b955060a08b0135945060c08b01356116fb816115d8565b935060e08b013592506101008b013567ffffffffffffffff81111561171f57600080fd5b61172b8d828e016115fc565b92505061173b6101208c016115a1565b90509295989b9194979a5092959850565b60008060006060848603121561176157600080fd5b833561176c8161158c565b9250602084013561177c8161158c565b929592945050506040919091013590565b60006020828403121561179f57600080fd5b5035919050565b600080604083850312156117b957600080fd5b8235915060208301356117cb8161158c565b809150509250929050565b6000602082840312156117e857600080fd5b8135610e8e8161158c565b60008060006060848603121561180857600080fd5b505081359360208301359350604090920135919050565b6000806040838503121561183257600080fd5b823567ffffffffffffffff81111561184957600080fd5b611855858286016115fc565b95602094909401359450505050565b60008060006060848603121561187957600080fd5b83356118848161158c565b925060208401359150604084013561189b8161158c565b809150509250925092565b600080604083850312156118b957600080fd5b82356118c48161158c565b915060208301356117cb8161158c565b600181811c908216806118e857607f821691505b60208210810361190857634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052601160045260246000fd5b6001815b600184111561195f578085048111156119435761194361190e565b600184161561195157908102905b60019390931c928002611928565b935093915050565b6000826119765750600161055c565b816119835750600061055c565b816001811461199957600281146119a3576119bf565b600191505061055c565b60ff8411156119b4576119b461190e565b50506001821b61055c565b5060208310610133831016604e8410600b84101617156119e2575081810a61055c565b6119ef6000198484611924565b8060001904821115611a0357611a0361190e565b029392505050565b6000610e8e60ff841683611967565b808202811582820484141761055c5761055c61190e565b600082611a4e57634e487b7160e01b600052601260045260246000fd5b500490565b6000610160820190506001600160a01b038d1682526001600160a01b038c1660208301526001600160a01b038b1660408301528960608301526001600160a01b03891660808301528760a08301526001600160a01b03871660c08301528560e083015284151561010083015283610120830152611adc6101408301846001600160a01b03169052565b9c9b505050505050505050505050565b60008251611afe818460208701611535565b9190910192915050565b600060208284031215611b1a57600080fd5b8151610e8e8161158c565b634e487b7160e01b600052602160045260246000fd5b600060208284031215611b4d57600080fd5b815160058110610e8e57600080fd5b600060208284031215611b6e57600080fd5b8151610e8e816115d8565b600060208284031215611b8b57600080fd5b5051919050565b600060208284031215611ba457600080fd5b815160ff81168114610e8e57600080fd5b8082018082111561055c5761055c61190e56fe6080604052600060118190556012805460ff1916905560135534801561002457600080fd5b506040516143e23803806143e28339810160408190526100439161028c565b600180546001600160a01b03199081166001600160a01b038e8116919091179092556003805482168d8416908117909155600580548316909117905560068a90556004805482168c84161790556009805482168a8416179055600b8890556000600c819055600f8054831689851617905560118790556012805460ff19168715151790556013859055601480549092169284169290921790556100e690886101c4565b506101117fff3317e1e0e8c784290b957ee9b65ea8fe96420c4819db463283b95ecbe4a3fe886101c4565b5061012a6000805160206143c2833981519152886101c4565b506101557f1b1d6daa0713d43f2f00de83db8637c0bad175a2741c64242b56899ba3dcdc01886101c4565b50600f5461017b906000805160206143c2833981519152906001600160a01b03166101c4565b50600f546101b3907f1b1d6daa0713d43f2f00de83db8637c0bad175a2741c64242b56899ba3dcdc01906001600160a01b03166101c4565b505050505050505050505050610347565b6000828152602081815260408083206001600160a01b038516845290915281205460ff16610266576000838152602081815260408083206001600160a01b03861684529091529020805460ff1916600117905561021e3390565b6001600160a01b0316826001600160a01b0316847f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a450600161026a565b5060005b92915050565b80516001600160a01b038116811461028757600080fd5b919050565b60008060008060008060008060008060006101608c8e0312156102ae57600080fd5b6102b78c610270565b9a506102c560208d01610270565b99506102d360408d01610270565b60608d015190995097506102e960808d01610270565b60a08d015190975095506102ff60c08d01610270565b60e08d01516101008e01519196509450801515811461031d57600080fd5b6101208d015190935091506103356101408d01610270565b90509295989b509295989b9093969950565b61406c806103566000396000f3fe608060405234801561001057600080fd5b50600436106103155760003560e01c806375417851116101a7578063b9780f33116100ee578063cf09e0d011610097578063e69e04b311610071578063e69e04b3146106fb578063e6c7c45614610704578063f6df28d01461070c57600080fd5b8063cf09e0d0146106cc578063d547741f146106d5578063e2c345e2146106e857600080fd5b8063bfcd0fc5116100c8578063bfcd0fc51461069e578063c22c4f43146106b1578063c3a2a93a146106c457600080fd5b8063b9780f331461065c578063be07dd561461066f578063bea6998f1461069657600080fd5b80639e57366511610150578063a326d9b71161012a578063a326d9b714610619578063b4f8570414610622578063b7fd96841461063557600080fd5b80639e573665146105eb5780639fe7947b146105fe578063a217fddf1461061157600080fd5b80638cbdd6bd116101815780638cbdd6bd1461059657806391d14854146105ab5780639bd3ba4e146105e257600080fd5b8063754178511461056b5780637aeabb39146105805780637ea0f6cb1461058957600080fd5b8063374558121161026b5780635c71c0df116102145780635ed185ef116101ee5780635ed185ef14610522578063623bf83d146105355780636bb2cd231461054857600080fd5b80635c71c0df146104d35780635d30e84d146104fc5780635e0a02ef1461050f57600080fd5b80634e52126e116102455780634e52126e1461049a5780634f8632ba146104ad578063570ca735146104c057600080fd5b806337455812146104695780633ab7704d14610472578063474da79a1461048757600080fd5b806316a207fc116102cd5780632f2ff15d116102a75780632f2ff15d14610429578063313ce5671461043c57806336568abe1461045657600080fd5b806316a207fc146103be57806320f0d83a146103f3578063248a9ca31461040657600080fd5b80630687b785116102fe5780630687b78514610357578063085d4883146103985780630f82d3a7146103ab57600080fd5b806301ffc9a71461031a57806305fe138b14610342575b600080fd5b61032d6103283660046122cf565b61071f565b60405190151581526020015b60405180910390f35b61035561035036600461232d565b6107b8565b005b61038061036536600461235d565b6017602052600090815260409020546001600160a01b031681565b6040516001600160a01b039091168152602001610339565b600954610380906001600160a01b031681565b6103556103b936600461237a565b61084e565b6103e57f1b1d6daa0713d43f2f00de83db8637c0bad175a2741c64242b56899ba3dcdc0181565b604051908152602001610339565b6103556104013660046123a8565b61095d565b6103e56104143660046123a8565b60009081526020819052604090206001015490565b61035561043736600461232d565b61096e565b610444610993565b60405160ff9091168152602001610339565b61035561046436600461232d565b610a08565b6103e560115481565b61047a610a59565b60405161033991906123c1565b6103806104953660046123a8565b610ae7565b61032d6104a836600461235d565b610b11565b600454610380906001600160a01b031681565b600f54610380906001600160a01b031681565b6103806104e136600461235d565b6016602052600090815260409020546001600160a01b031681565b6103e561050a3660046123a8565b610f48565b61035561051d36600461241d565b610f69565b610355610530366004612468565b610f8f565b600554610380906001600160a01b031681565b61032d61055636600461235d565b60156020526000908152604090205460ff1681565b61057361105e565b6040516103399190612521565b6103e560075481565b60125461032d9060ff1681565b61059e6110c0565b604051610339919061256d565b61032d6105b936600461232d565b6000918252602082815260408084206001600160a01b0393909316845291905290205460ff1690565b6103e5600c5481565b600354610380906001600160a01b031681565b61038061060c3660046125a5565b611117565b6103e5600081565b6103e560135481565b610355610630366004612468565b61169c565b6103e57fff3317e1e0e8c784290b957ee9b65ea8fe96420c4819db463283b95ecbe4a3fe81565b600154610380906001600160a01b031681565b6103e57f9abc57040bfcfa57b85b08824ec5ac8a2760aa67e3edf2af636feb2f0b09ff6f81565b61047a6116d2565b6103556106ac3660046123a8565b6116df565b6103806106bf3660046123a8565b611e31565b610573611e41565b6103e560025481565b6103556106e336600461232d565b611ece565b601454610380906001600160a01b031681565b6103e560065481565b6103e5611ef3565b61035561071a36600461235d565b611f64565b60007fffffffff0000000000000000000000000000000000000000000000000000000082167f7965db0b0000000000000000000000000000000000000000000000000000000014806107b257507f01ffc9a7000000000000000000000000000000000000000000000000000000007fffffffff000000000000000000000000000000000000000000000000000000008316145b92915050565b7fff3317e1e0e8c784290b957ee9b65ea8fe96420c4819db463283b95ecbe4a3fe6107e281611f9c565b826107eb611ef3565b101561083e5760405162461bcd60e51b815260206004820181905260248201527f4e6f7420656e6f75676874206d6f6e657920666f72207769746864726177616c60448201526064015b60405180910390fd5b6108488284611fa6565b50505050565b6001546001600160a01b031633146108a85760405162461bcd60e51b815260206004820152600a60248201527f4f6e6c7920746f6b656e000000000000000000000000000000000000000000006044820152606401610835565b6001600160a01b0382811660009081526017602090815260409182902080546001600160a01b03191693851693909317909255513381527f54db7a5cb4735e1aac1f53db512d3390390bb6637bd30ad4bf9fc98667d9b9b9910160405180910390a1600e80546001810182556000919091527fbb7b4a454dc3493923482f07822329ed19e8244eff582cc204f8554c3620c3fd0180546001600160a01b0319166001600160a01b039290921691909117905550565b600061096881611f9c565b50601155565b60008281526020819052604090206001015461098981611f9c565b610848838361209e565b6003546040805163313ce56760e01b815290516000926001600160a01b03169163313ce5679160048083019260209291908290030181865afa9250505080156109f9575060408051601f3d908101601f191682019092526109f6918101906125de565b60015b610a035750600090565b919050565b6001600160a01b0381163314610a4a576040517f6697b23200000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b610a548282612148565b505050565b60088054610a6690612601565b80601f0160208091040260200160405190810160405280929190818152602001828054610a9290612601565b8015610adf5780601f10610ab457610100808354040283529160200191610adf565b820191906000526020600020905b815481529060010190602001808311610ac257829003601f168201915b505050505081565b600d8181548110610af757600080fd5b6000918252602090912001546001600160a01b0316905081565b601254600090829060ff161515600103610f3f576000816001600160a01b0316637aeabb396040518163ffffffff1660e01b8152600401602060405180830381865afa158015610b65573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b89919061263b565b118015610c0c57506001546040805163b9780f3360e01b815290516001600160a01b039283169284169163b9780f339160048083019260209291908290030181865afa158015610bdd573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c019190612654565b6001600160a01b0316145b8015610ca75750600554604080517f623bf83d00000000000000000000000000000000000000000000000000000000815290516001600160a01b039283169284169163623bf83d9160048083019260209291908290030181865afa158015610c78573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c9c9190612654565b6001600160a01b0316145b8015610d155750600654816001600160a01b031663e69e04b36040518163ffffffff1660e01b8152600401602060405180830381865afa158015610cef573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d13919061263b565b145b8015610db05750600954604080517f085d488300000000000000000000000000000000000000000000000000000000815290516001600160a01b039283169284169163085d48839160048083019260209291908290030181865afa158015610d81573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610da59190612654565b6001600160a01b0316145b8015610e2e5750306001600160a01b0316816001600160a01b031663e2c345e26040518163ffffffff1660e01b8152600401602060405180830381865afa158015610dff573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610e239190612654565b6001600160a01b0316145b610e7a5760405162461bcd60e51b815260206004820152601060248201527f5061796d656e74207265717569726564000000000000000000000000000000006044820152606401610835565b60135415610f3f57601354816001600160a01b0316637aeabb396040518163ffffffff1660e01b8152600401602060405180830381865afa158015610ec3573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ee7919061263b565b610ef19190612687565b4210610f3f5760405162461bcd60e51b815260206004820152601460248201527f537562736372697074696f6e20657870697265640000000000000000000000006044820152606401610835565b50600192915050565b60108181548110610f5857600080fd5b600091825260209091200154905081565b6000610f7481611f9c565b506012805460ff191693151593909317909255601355600655565b6004546001600160a01b03163314610fe95760405162461bcd60e51b815260206004820152600960248201527f4f6e6c79207573657200000000000000000000000000000000000000000000006044820152606401610835565b600654610ff4611ef3565b10156110425760405162461bcd60e51b815260206004820152601960248201527f596f75206e65656420746f2070617920746865207072696365000000000000006044820152606401610835565b42600755600861105282826126e1565b5061105b6121cb565b50565b6060600e8054806020026020016040519081016040528092919081815260200182805480156110b657602002820191906000526020600020905b81546001600160a01b03168152600190910190602001808311611098575b5050505050905090565b606060108054806020026020016040519081016040528092919081815260200182805480156110b657602002820191906000526020600020905b8154815260200190600101908083116110fa575050505050905090565b600061112282610b11565b50336000908152601660205260409020546001600160a01b03163081148061115157506001600160a01b038116155b61119d5760405162461bcd60e51b815260206004820152601c60248201527f50726576696f7573206f726465722073686f756c642066696e697368000000006044820152606401610835565b600154604080517f32a30d4c00000000000000000000000000000000000000000000000000000000815290516001600160a01b039092169160009183916332a30d4c916004808201926020929091908290030181865afa158015611205573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611229919061263b565b86836001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa158015611268573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061128c91906125de565b61129790600a612887565b6112a1908a612896565b6112ab91906128ad565b6112b591906128ad565b6005546040517fe31e2cab0000000000000000000000000000000000000000000000000000000081526001600160a01b039182166004820152919250600091889185169063e31e2cab90602401602060405180830381865afa15801561131f573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061134391906125de565b61134e90600a612887565b611358908a612896565b61136291906128ad565b6003546040516370a0823160e01b815233600482015291925082916001600160a01b03909116906370a0823190602401602060405180830381865afa1580156113af573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906113d3919061263b565b10156114475760405162461bcd60e51b815260206004820152602960248201527f596f75722062616c616e63652073686f756c642068617665207468652072657160448201527f75697265642073756d00000000000000000000000000000000000000000000006064820152608401610835565b6000836001600160a01b03166339a36ea56040518163ffffffff1660e01b8152600401602060405180830381865afa158015611487573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906114ab919061263b565b6040517f7b47ec1a000000000000000000000000000000000000000000000000000000008152600481018590529091506001600160a01b03851690637b47ec1a90602401600060405180830381600087803b15801561150957600080fd5b505af115801561151d573d6000803e3d6000fd5b5050600154600554604080517fbb5bc87f0000000000000000000000000000000000000000000000000000000081529051600095506001600160a01b039384169450918316928692908a169163bb5bc87f9160048083019260209291908290030181865afa158015611593573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906115b7919061263b565b868833306040516115c7906122c2565b6001600160a01b039889168152968816602088015260408701959095526060860193909352608085019190915260a0840152831660c083015290911660e082015261010001604051809103906000f080158015611628573d6000803e3d6000fd5b5033600090815260166020526040812080546001600160a01b0384166001600160a01b03199182168117909255600d805460018101825593527fd7b6990105719101dabeb77144f2a3385c8033acd3af97e9423a695e81ad1eb5909201805490921617905596505050505050509392505050565b7f9abc57040bfcfa57b85b08824ec5ac8a2760aa67e3edf2af636feb2f0b09ff6f6116c681611f9c565b600a610a5483826126e1565b600a8054610a6690612601565b60003390506000816001600160a01b0316637150d8ae6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611724573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906117489190612654565b905060115460000361177d576001600160a01b0316600090815260166020526040902080546001600160a01b03191690555050565b3360009081526015602052604090205460ff16156117dd5760405162461bcd60e51b815260206004820152601c60248201527f5468697320726174696e6720697320616c7265616479206164646564000000006044820152606401610835565b6001600160a01b038181166000908152601660205260409020541633146118465760405162461bcd60e51b815260206004820152601b60248201527f427579657220686173206120646966666572656e74206f7264657200000000006044820152606401610835565b33600090815260156020908152604091829020805460ff1916600190811790915554825163b9780f3360e01b815292516001600160a01b03918216939186169263b9780f3392600480820193918290030181865afa1580156118ac573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906118d09190612654565b6001600160a01b03161461194c5760405162461bcd60e51b815260206004820152602c60248201527f54686520636f6e74726163742073686f756c64206265206f776e65642062792060448201527f7468652065786368616e676500000000000000000000000000000000000000006064820152608401610835565b306001600160a01b0316826001600160a01b0316635b8d02d76040518163ffffffff1660e01b8152600401602060405180830381865afa158015611994573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906119b89190612654565b6001600160a01b031614611a345760405162461bcd60e51b815260206004820152602d60248201527f54686520636f6e74726163742073686f756c64206265206c696e6b656420746f60448201527f20746869732073657276696365000000000000000000000000000000000000006064820152608401610835565b6001546040805163313ce56760e01b815290516001600160a01b0390921691600091839163313ce567916004808201926020929091908290030181865afa158015611a83573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611aa791906125de565b611ab290600a612887565b611abc9086612896565b9050600085118015611ada5750601154611ad7906001612687565b85105b611b4c5760405162461bcd60e51b815260206004820152603160248201527f526174696e672073697a652073686f756c64206265207365742062792074686560448201527f20736572766963652070726f76696465720000000000000000000000000000006064820152608401610835565b6040516370a0823160e01b815230600482015281906001600160a01b038416906370a0823190602401602060405180830381865afa158015611b92573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611bb6919061263b565b11611c295760405162461bcd60e51b815260206004820152602d60248201527f546865207365727669636520686173206e6f204558434420746f20706179206660448201527f6f722074686520726174696e67000000000000000000000000000000000000006064820152608401610835565b6004846001600160a01b031663c19d93fb6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611c69573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611c8d91906128e5565b6004811115611c9e57611c9e6128cf565b14611ceb5760405162461bcd60e51b815260206004820181905260248201527f526571756972657320696e61637469766520636f6e74726163742073746174656044820152606401610835565b601080546001810182556000919091527f1b6847dc741a1b0cd08d278845f9d819d87b734759afb55fe2de5cb82a9ae6720185905560405163095ea7b360e01b8152306004820152602481018290526001600160a01b0383169063095ea7b3906044016020604051808303816000875af1158015611d6d573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611d919190612906565b5060405163a9059cbb60e01b81526001600160a01b0384811660048301526024820183905283169063a9059cbb906044016020604051808303816000875af1158015611de1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611e059190612906565b5050506001600160a01b0316600090815260166020526040902080546001600160a01b03191690555050565b600e8181548110610af757600080fd5b60607f1b1d6daa0713d43f2f00de83db8637c0bad175a2741c64242b56899ba3dcdc01611e6d81611f9c565b600d805480602002602001604051908101604052809291908181526020018280548015611ec357602002820191906000526020600020905b81546001600160a01b03168152600190910190602001808311611ea5575b505050505091505090565b600082815260208190526040902060010154611ee981611f9c565b6108488383612148565b6003546040516370a0823160e01b815230600482015260009182916001600160a01b03909116906370a0823190602401602060405180830381865afa158015611f40573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107b2919061263b565b6000611f6f81611f9c565b50600380546001600160a01b039092166001600160a01b0319928316811790915560058054909216179055565b61105b8133612252565b60035460405163095ea7b360e01b8152306004820152602481018390526000916001600160a01b03169063095ea7b3906044016020604051808303816000875af1158015611ff8573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061201c9190612906565b5060035460405163a9059cbb60e01b81526001600160a01b038581166004830152602482018590529091169063a9059cbb906044016020604051808303816000875af1158015612070573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906120949190612906565b5060019392505050565b6000828152602081815260408083206001600160a01b038516845290915281205460ff16612140576000838152602081815260408083206001600160a01b03861684529091529020805460ff191660011790556120f83390565b6001600160a01b0316826001600160a01b0316847f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45060016107b2565b5060006107b2565b6000828152602081815260408083206001600160a01b038516845290915281205460ff1615612140576000838152602081815260408083206001600160a01b0386168085529252808320805460ff1916905551339286917ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9190a45060016107b2565b600060646006546121dc91906128ad565b9050600081600b546121ee9190612896565b9050600082600c546122009190612896565b9050600061220e8284612687565b60065461221b9190612923565b600154909150612234906001600160a01b031684611fa6565b5060095461224b906001600160a01b031682611fa6565b5050505050565b6000828152602081815260408083206001600160a01b038516845290915290205460ff166122be576040517fe2517d3f0000000000000000000000000000000000000000000000000000000081526001600160a01b038216600482015260248101839052604401610835565b5050565b6117008061293783390190565b6000602082840312156122e157600080fd5b81357fffffffff000000000000000000000000000000000000000000000000000000008116811461231157600080fd5b9392505050565b6001600160a01b038116811461105b57600080fd5b6000806040838503121561234057600080fd5b82359150602083013561235281612318565b809150509250929050565b60006020828403121561236f57600080fd5b813561231181612318565b6000806040838503121561238d57600080fd5b823561239881612318565b9150602083013561235281612318565b6000602082840312156123ba57600080fd5b5035919050565b602081526000825180602084015260005b818110156123ef57602081860181015160408684010152016123d2565b506000604082850101526040601f19601f83011684010191505092915050565b801515811461105b57600080fd5b60008060006060848603121561243257600080fd5b833561243d8161240f565b95602085013595506040909401359392505050565b634e487b7160e01b600052604160045260246000fd5b60006020828403121561247a57600080fd5b813567ffffffffffffffff81111561249157600080fd5b8201601f810184136124a257600080fd5b803567ffffffffffffffff8111156124bc576124bc612452565b604051601f8201601f19908116603f0116810167ffffffffffffffff811182821017156124eb576124eb612452565b60405281815282820160200186101561250357600080fd5b81602084016020830137600091810160200191909152949350505050565b602080825282518282018190526000918401906040840190835b818110156125625783516001600160a01b031683526020938401939092019160010161253b565b509095945050505050565b602080825282518282018190526000918401906040840190835b81811015612562578351835260209384019390920191600101612587565b6000806000606084860312156125ba57600080fd5b833592506020840135915060408401356125d381612318565b809150509250925092565b6000602082840312156125f057600080fd5b815160ff8116811461231157600080fd5b600181811c9082168061261557607f821691505b60208210810361263557634e487b7160e01b600052602260045260246000fd5b50919050565b60006020828403121561264d57600080fd5b5051919050565b60006020828403121561266657600080fd5b815161231181612318565b634e487b7160e01b600052601160045260246000fd5b808201808211156107b2576107b2612671565b601f821115610a5457806000526020600020601f840160051c810160208510156126c15750805b601f840160051c820191505b8181101561224b57600081556001016126cd565b815167ffffffffffffffff8111156126fb576126fb612452565b61270f816127098454612601565b8461269a565b6020601f821160018114612743576000831561272b5750848201515b600019600385901b1c1916600184901b17845561224b565b600084815260208120601f198516915b828110156127735787850151825560209485019460019092019101612753565b50848210156127915786840151600019600387901b60f8161c191681555b50505050600190811b01905550565b6001815b60018411156127db578085048111156127bf576127bf612671565b60018416156127cd57908102905b60019390931c9280026127a4565b935093915050565b6000826127f2575060016107b2565b816127ff575060006107b2565b8160018114612815576002811461281f5761283b565b60019150506107b2565b60ff84111561283057612830612671565b50506001821b6107b2565b5060208310610133831016604e8410600b841016171561285e575081810a6107b2565b61286b60001984846127a0565b806000190482111561287f5761287f612671565b029392505050565b600061231160ff8416836127e3565b80820281158282048414176107b2576107b2612671565b6000826128ca57634e487b7160e01b600052601260045260246000fd5b500490565b634e487b7160e01b600052602160045260246000fd5b6000602082840312156128f757600080fd5b81516005811061231157600080fd5b60006020828403121561291857600080fd5b81516123118161240f565b818103818111156107b2576107b261267156fe60c0604052600c805461ffff60a01b191690556000600d5534801561002357600080fd5b506040516117003803806117008339810160408190526100429161011e565b6001600160a01b03808916608052871660a0819052600980546001600160a01b0319169091179055600486905560058590554260065560008490556100886064856101b1565b6001819055600454610099916101d3565b60028190556000546100ab91906101f0565b600355600892909255600c80546001600160a81b0319166001600160a01b0393841617600160a01b17905560078054919092166001600160a01b03199091161790555050600e805460ff1916905550610203915050565b80516001600160a01b038116811461011957600080fd5b919050565b600080600080600080600080610100898b03121561013b57600080fd5b61014489610102565b975061015260208a01610102565b60408a015160608b015160808c015160a08d0151939a5091985096509450925061017e60c08a01610102565b915061018c60e08a01610102565b90509295985092959890939650565b634e487b7160e01b600052601160045260246000fd5b6000826101ce57634e487b7160e01b600052601260045260246000fd5b500490565b80820281158282048414176101ea576101ea61019b565b92915050565b818103818111156101ea576101ea61019b565b60805160a0516114ae610252600039600081816102b10152818161038a01528181610f110152818161100b01526110c00152600081816103260152818161059e0152610f9801526114ae6000f3fe608060405234801561001057600080fd5b50600436106101ae5760003560e01c80639e01ff2e116100ee578063a6abf16a11610097578063c19d93fb11610071578063c19d93fb14610348578063cf09e0d014610362578063d17c2b541461036b578063e6c7c4561461037e57600080fd5b8063a6abf16a146102f5578063ab460a2614610319578063b9780f331461032157600080fd5b8063a0c97bce116100c8578063a0c97bce146102dc578063a166fdb7146102e4578063a3f8a30a146102ed57600080fd5b80639e01ff2e146102995780639e573665146102ac578063a035b1fe146102d357600080fd5b806363bd1d4a1161015b5780637150d8ae116101355780637150d8ae1461026c57806373f425611461027f57806373fac6f01461028857806380f474f61461029057600080fd5b806363bd1d4a146102455780636d534a141461024e57806370ba11131461026357600080fd5b80635b8d02d71161018c5780635b8d02d7146101f2578063618260451461021d578063623bf83d1461023257600080fd5b80630d668087146101b3578063313ce567146101cf5780633a4b4532146101e9575b600080fd5b6101bc60055481565b6040519081526020015b60405180910390f35b6101d7610386565b60405160ff90911681526020016101c6565b6101bc60025481565b600c54610205906001600160a01b031681565b6040516001600160a01b0390911681526020016101c6565b61023061022b36600461114d565b610411565b005b600954610205906001600160a01b031681565b6101bc60035481565b610256610607565b6040516101c69190611206565b6101bc60015481565b600754610205906001600160a01b031681565b6101bc60085481565b610230610695565b6101bc600d5481565b6102306102a736600461114d565b610710565b6102057f000000000000000000000000000000000000000000000000000000000000000081565b6101bc60005481565b6102306108a8565b6101bc60045481565b610256610ae5565b600c5461030990600160a81b900460ff1681565b60405190151581526020016101c6565b610230610af2565b6102057f000000000000000000000000000000000000000000000000000000000000000081565b600e546103559060ff1681565b6040516101c6919061126a565b6101bc60065481565b610230610379366004611292565b610c96565b6101bc610ed6565b60007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663313ce5676040518163ffffffff1660e01b8152600401602060405180830381865afa925050508015610402575060408051601f3d908101601f191682019092526103ff918101906112ab565b60015b61040c5750600090565b919050565b600080600e5460ff16600481111561042b5761042b611254565b146104495760405163baf3f0f760e01b815260040160405180910390fd5b6007546001600160a01b03163314610474576040516386efbb5560e01b815260040160405180910390fd5b6000306001600160a01b031663e6c7c4566040518163ffffffff1660e01b8152600401602060405180830381865afa1580156104b4573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906104d891906112d5565b905060005481146105565760405162461bcd60e51b815260206004820152602260248201527f506c656173652073656e6420696e2074686520707572636861736520616d6f7560448201527f6e7400000000000000000000000000000000000000000000000000000000000060648201526084015b60405180910390fd5b600e805460ff19166001179055600b61056f8482611376565b506040517f4791abe10000000000000000000000000000000000000000000000000000000081523060048201527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031690634791abe190602401600060405180830381600087803b1580156105ea57600080fd5b505af11580156105fe573d6000803e3d6000fd5b50505050505050565b600b8054610614906112ee565b80601f0160208091040260200160405190810160405280929190818152602001828054610640906112ee565b801561068d5780601f106106625761010080835404028352916020019161068d565b820191906000526020600020905b81548152906001019060200180831161067057829003601f168201915b505050505081565b6007546001600160a01b031633146106c0576040516386efbb5560e01b815260040160405180910390fd5b600280600e5460ff1660048111156106da576106da611254565b146106f85760405163baf3f0f760e01b815260040160405180910390fd5b600e805460ff1916600417905561070d610f82565b50565b600180600e5460ff16600481111561072a5761072a611254565b146107485760405163baf3f0f760e01b815260040160405180910390fd5b600c54604080516305a881ff60e21b815290516001600160a01b039092169182916391d148549183916316a207fc9160048083019260209291908290030181865afa15801561079b573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107bf91906112d5565b6040517fffffffff0000000000000000000000000000000000000000000000000000000060e084901b1681526004810191909152336024820152604401602060405180830381865afa158015610819573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061083d9190611435565b6108895760405162461bcd60e51b815260206004820152601760248201527f5265737472696374656420746f206f70657261746f722e000000000000000000604482015260640161054d565b600e805460ff19166002179055600a6108a28482611376565b50505050565b600c54604080516305a881ff60e21b815290516001600160a01b039092169182916391d148549183916316a207fc9160048083019260209291908290030181865afa1580156108fb573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061091f91906112d5565b6040517fffffffff0000000000000000000000000000000000000000000000000000000060e084901b1681526004810191909152336024820152604401602060405180830381865afa158015610979573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061099d9190611435565b6109e95760405162461bcd60e51b815260206004820152601760248201527f5265737472696374656420746f206f70657261746f722e000000000000000000604482015260640161054d565b600280600e5460ff166004811115610a0357610a03611254565b14610a215760405163baf3f0f760e01b815260040160405180910390fd5b600554600654610a319190611457565b421015610acc5760405162461bcd60e51b815260206004820152605260248201527f506c65617365207761697420756e74696c20746865206d6f6e6579206973207260448201527f656c65617365642066726f6d206465706f736974206f7220746865206275796560648201527f7220636f6e6669726d7320726563656976650000000000000000000000000000608482015260a40161054d565b600e805460ff19166004179055610ae1610f82565b5050565b600a8054610614906112ee565b600c54604080516305a881ff60e21b815290516001600160a01b039092169182916391d148549183916316a207fc9160048083019260209291908290030181865afa158015610b45573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b6991906112d5565b6040517fffffffff0000000000000000000000000000000000000000000000000000000060e084901b1681526004810191909152336024820152604401602060405180830381865afa158015610bc3573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610be79190611435565b610c335760405162461bcd60e51b815260206004820152601760248201527f5265737472696374656420746f206f70657261746f722e000000000000000000604482015260640161054d565b600180600e5460ff166004811115610c4d57610c4d611254565b14610c6b5760405163baf3f0f760e01b815260040160405180910390fd5b600e805460ff19166004179055600754600054610c91916001600160a01b031690610fd3565b505050565b600480600e5460ff166004811115610cb057610cb0611254565b14610cce5760405163baf3f0f760e01b815260040160405180910390fd5b600c54600160a81b900460ff161580610ce75750600d54155b610d335760405162461bcd60e51b815260206004820152601560248201527f526174696e6720697320616c7265616479207365740000000000000000000000604482015260640161054d565b600c546001600160a01b03168215801590610db95750806001600160a01b031663374558126040518163ffffffff1660e01b8152600401602060405180830381865afa158015610d87573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610dab91906112d5565b610db6906001611457565b83105b610e2b5760405162461bcd60e51b815260206004820152603160248201527f526174696e672073697a652073686f756c64206265207365742062792074686560448201527f20736572766963652070726f7669646572000000000000000000000000000000606482015260840161054d565b600d8390556040517fbfcd0fc5000000000000000000000000000000000000000000000000000000008152600481018490526001600160a01b0382169063bfcd0fc590602401600060405180830381600087803b158015610e8b57600080fd5b505af1158015610e9f573d6000803e3d6000fd5b5050600c80547fffffffffffffffffffff00ffffffffffffffffffffffffffffffffffffffffff16600160a81b1790555050505050565b6040517f70a0823100000000000000000000000000000000000000000000000000000000815230600482015260009081906001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016906370a0823190602401602060405180830381865afa158015610f58573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f7c91906112d5565b92915050565b600e805460ff19166004179055600254610fbd907f000000000000000000000000000000000000000000000000000000000000000090610fd3565b50600c5460035461070d916001600160a01b0316905b6040517f095ea7b3000000000000000000000000000000000000000000000000000000008152306004820152602481018290526000907f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03169063095ea7b3906044016020604051808303816000875af115801561105c573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906110809190611435565b506040517fa9059cbb0000000000000000000000000000000000000000000000000000000081526001600160a01b038481166004830152602482018490527f0000000000000000000000000000000000000000000000000000000000000000169063a9059cbb906044016020604051808303816000875af1158015611109573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061112d9190611435565b5060019392505050565b634e487b7160e01b600052604160045260246000fd5b60006020828403121561115f57600080fd5b813567ffffffffffffffff81111561117657600080fd5b8201601f8101841361118757600080fd5b803567ffffffffffffffff8111156111a1576111a1611137565b604051601f8201601f19908116603f0116810167ffffffffffffffff811182821017156111d0576111d0611137565b6040528181528282016020018610156111e857600080fd5b81602084016020830137600091810160200191909152949350505050565b602081526000825180602084015260005b818110156112345760208186018101516040868401015201611217565b506000604082850101526040601f19601f83011684010191505092915050565b634e487b7160e01b600052602160045260246000fd5b602081016005831061128c57634e487b7160e01b600052602160045260246000fd5b91905290565b6000602082840312156112a457600080fd5b5035919050565b6000602082840312156112bd57600080fd5b815160ff811681146112ce57600080fd5b9392505050565b6000602082840312156112e757600080fd5b5051919050565b600181811c9082168061130257607f821691505b60208210810361132257634e487b7160e01b600052602260045260246000fd5b50919050565b601f821115610c9157806000526020600020601f840160051c8101602085101561134f5750805b601f840160051c820191505b8181101561136f576000815560010161135b565b5050505050565b815167ffffffffffffffff81111561139057611390611137565b6113a48161139e84546112ee565b84611328565b6020601f8211600181146113d857600083156113c05750848201515b600019600385901b1c1916600184901b17845561136f565b600084815260208120601f198516915b8281101561140857878501518255602094850194600190920191016113e8565b50848210156114265786840151600019600387901b60f8161c191681555b50505050600190811b01905550565b60006020828403121561144757600080fd5b815180151581146112ce57600080fd5b80820180821115610f7c57634e487b7160e01b600052601160045260246000fdfea26469706673582212201d40811dc8e4d28c088ead892b195cff48ed0e68b8e953c3d79db3581be13f6764736f6c634300081a0033a2646970667358221220f0372241cadf287c4bd63f3af492affbc2dac8fda80326397897cc7596a1901064736f6c634300081a00339abc57040bfcfa57b85b08824ec5ac8a2760aa67e3edf2af636feb2f0b09ff6fa2646970667358221220f0b405a6e4ea0c4c1849425aac3e332708a2b11f9b72e3cff4d4dbae0873276564736f6c634300081a0033';

type ExchangeTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ExchangeTokenConstructorParams,
): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class ExchangeToken__factory extends ContractFactory {
  constructor(...args: ExchangeTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    creator: AddressLike,
    _name: string,
    _symbol: string,
    overrides?: NonPayableOverrides & {from?: string},
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      creator,
      _name,
      _symbol,
      overrides || {},
    );
  }
  override deploy(
    creator: AddressLike,
    _name: string,
    _symbol: string,
    overrides?: NonPayableOverrides & {from?: string},
  ) {
    return super.deploy(
      creator,
      _name,
      _symbol,
      overrides || {},
    ) as Promise<
      ExchangeToken & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(
    runner: ContractRunner | null,
  ): ExchangeToken__factory {
    return super.connect(runner) as ExchangeToken__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ExchangeTokenInterface {
    return new Interface(_abi) as ExchangeTokenInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null,
  ): ExchangeToken {
    return new Contract(
      address,
      _abi,
      runner,
    ) as unknown as ExchangeToken;
  }
}
